import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconWarningFill = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.425 19.5a.876.876 0 0 1-.772-.452.956.956 0 0 1-.128-.437.816.816 0 0 1 .127-.467l8.561-14.788A.897.897 0 0 1 12 2.904a.897.897 0 0 1 .787.452l8.56 14.788c.093.154.136.31.128.467a.955.955 0 0 1-.129.437.876.876 0 0 1-.771.452H3.425ZM12 16.808c.229 0 .42-.078.575-.232a.782.782 0 0 0 .233-.576.781.781 0 0 0-.232-.575.781.781 0 0 0-.576-.233.781.781 0 0 0-.575.233.781.781 0 0 0-.233.575c0 .229.078.42.232.576a.781.781 0 0 0 .576.232Zm0-2.616a.725.725 0 0 0 .534-.215.727.727 0 0 0 .216-.535v-3.5a.725.725 0 0 0-.216-.534.726.726 0 0 0-.534-.216.724.724 0 0 0-.534.216.725.725 0 0 0-.216.534v3.5c0 .213.072.391.216.535a.726.726 0 0 0 .534.215Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconWarningFill;
